/* eslint-disable no-console */
/**
 * @typedef {Object} TemplateAPIResponse
 * @prop {any} [data]
 * @prop {number} success
 * @prop {string} function
 * @prop {string} [error_code]
 * @prop {string} [message]
 */

export class TemplateAPIClient {

	/**
	 * @type {string}
	 */
	endpoint = window.mivaJS.API_Url;

	/**
	 * @param {string} functionName
	 * @param {any} [body]
	 * @returns {Promise<TemplateAPIResponse>}
	 */
	async fetch (functionName, body = {}) {
		const response = await fetch(this.endpoint, {
			body: JSON.stringify({
				Function: functionName,
				...body
			}),
			method: 'POST'
		});

		// Throw error if HTTP request fails
		if (!response.ok) {
			throw new Error(`${this.constructor.name} :: There was an error with your request.`);
		}

		/**
		 * @type {TemplateAPIResponse}
		 */
		const jsonResponse = await response.json();

		return jsonResponse;
	}
};
